import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from '@goodsteward/gs-ui';
import { useStartStripeOnboarding } from '@/api/stripeAccount';

// /settings/stripe/refresh — Stripe redirects here when the one-time
// Account Link expires before the practice finishes onboarding (~5
// minute TTL). We re-mint and redirect.
//
// Phase 0b of docs/build-plans/pma-stripe-payments.md.

export function StripeRefreshPage() {
    const start = useStartStripeOnboarding();
    const [error, setError] = useState<string | null>(null);
    const fired = useRef(false);

    useEffect(() => {
        if (fired.current) return;
        fired.current = true;
        start.mutateAsync()
            .then((result) => {
                window.location.href = result.url;
            })
            .catch((err) => setError(err instanceof Error ? err.message : 'Could not start onboarding.'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="max-w-2xl p-6">
            <h1 className="text-2xl font-semibold text-text mb-3">Resuming Stripe onboarding…</h1>
            {error ? (
                <>
                    <Alert variant="danger" className="mb-4">{error}</Alert>
                    <p>
                        <Link
                            to="/configuration"
                            className="text-accent-text hover:underline"
                        >
                            ← Back to billing settings
                        </Link>
                    </p>
                </>
            ) : (
                <p className="text-text-subtle">
                    Generating a fresh onboarding link with Stripe. You'll be
                    redirected in a moment.
                </p>
            )}
        </div>
    );
}
